/**
 * The included platform services, as NON-EDITABLE status chips.
 *
 * No `<input>`, no `<button>`, no `onChange`: there is nothing here to
 * switch. Drawn as a plain list so assistive technology reads them as
 * facts rather than as controls that happen to be off (a list item takes
 * no `aria-disabled`, and `<ul>` is already a list — CRA's a11y lint
 * refuses both, and the build treats its warnings as errors). The
 * same component is mounted on the Create form (above the Demo Connections
 * toggle, so the operator sees what is included BEFORE deciding what to
 * add), on the confirmation, and on the tenant detail card.
 */
import React from 'react';
import { HardDrive, Mail } from 'lucide-react';

import { describeManagedServices } from './managedServices';

/** Flat, monochrome, 16px. A category marker, never artwork. */
const SERVICE_GLYPH = {
  storage: HardDrive,
  email: Mail,
};

export default function ManagedServicesChips({ services, testIdPrefix = 'managed-service' }) {
  const rows = Array.isArray(services) ? services : describeManagedServices(services);
  return (
    <ul
      aria-label="Included platform services"
      className="flex flex-wrap gap-2"
      data-testid={`${testIdPrefix}-chips`}
    >
      {rows.map((row) => {
        const Glyph = SERVICE_GLYPH[row.key];
        const other = row.status !== 'included';
        return (
          <li
            key={row.key}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs ${
              other ? 'border-warning/40 bg-warning/10 text-foreground' : 'border-border bg-muted/40 text-foreground'}`}
            data-testid={`${testIdPrefix}-${row.key}`}
            data-status={row.status}
          >
            {Glyph && <Glyph className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden="true" />}
            <span className="font-medium">{row.label}</span>
            <span className="text-muted-foreground">· {row.statusLabel}</span>
          </li>
        );
      })}
    </ul>
  );
}
